import { getInstance } from './authentication.factory'
import type { LoginOptions } from './models'

export const login = async (options?: LoginOptions) => await (await getInstance()).login(options?.inflightPathname)

/*
  In the container while we are doing automatic process (refresh, 401 on page opening)
  we want to be abe to login once and only once pending the user/browser response
*/
export const loginOnce = async () => await (await getInstance()).loginOnce()

export const logout = async () => await (await getInstance()).logout()

export const auth = async () => await (await getInstance()).auth()

export const isAuthenticationRequired = async () => (await getInstance()).isAuthenticationRequired()

export const setUnguardedRoutes = async (unguardedRoutes: readonly string[]) =>
  (await getInstance()).setUnguardedRoutes(unguardedRoutes)
